import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { flatten, uniq, values } from "lodash";

import { EmployeeSatisfactionSurveyForm } from "@teamprevent/common/employeeSatisfactionSurvey/components/EmployeeSatisfactionSurveyForm";
import {
    EmployeeSatisfactionSurveyModel,
    EMPLOYEE_SATISFACTION_SURVEY_KEY
} from "@teamprevent/common/employeeSatisfactionSurvey/models";
import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { ApplicationState } from "../../applicationState";
import { loadEmployeeSatisfactionSurvey } from "../actions";

export const EmployeeSatisfactionSurvey: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);
    const taskId = useSelector((state: ApplicationState) => state.router.params?.taskId);
    const stateQuestionnaire = useSelector((state: ApplicationState) => state.questionnaires[EMPLOYEE_SATISFACTION_SURVEY_KEY]);
    const questions: AnsweredQuestionWithId[] = uniq(flatten(stateQuestionnaire?.sections?.map(section => values(section.questions))));
    const eTag = stateQuestionnaire?.eTag;
    const feedbackQuestionnaire: EmployeeSatisfactionSurveyModel = { questions, eTag };

    const loadQuestionnaire = async () => {
        dispatch(loadEmployeeSatisfactionSurvey(customerId, taskId));
    };

    return (
        <EmployeeSatisfactionSurveyForm
            isReadonly={true}
            questionnaire={feedbackQuestionnaire}
            loadQuestionnaire={loadQuestionnaire}
        />
    );
};
